var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.8333C0 13.5321 1.86548 11.6666 4.16667 11.6666H10.8333C13.1345 11.6666 15 13.5321 15 15.8333V17.5C15 17.9602 14.6269 18.3333 14.1667 18.3333C13.7064 18.3333 13.3333 17.9602 13.3333 17.5V15.8333C13.3333 14.4526 12.214 13.3333 10.8333 13.3333H4.16667C2.78595 13.3333 1.66667 14.4526 1.66667 15.8333V17.5C1.66667 17.9602 1.29357 18.3333 0.833333 18.3333C0.373096 18.3333 0 17.9602 0 17.5V15.8333Z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 5.83329C3.3335 3.53211 5.19898 1.66663 7.50016 1.66663C9.80135 1.66663 11.6668 3.53211 11.6668 5.83329C11.6668 8.13448 9.80135 9.99996 7.50016 9.99996C5.19898 9.99996 3.3335 8.13448 3.3335 5.83329ZM7.50016 3.33329C6.11945 3.33329 5.00016 4.45258 5.00016 5.83329C5.00016 7.214 6.11945 8.33329 7.50016 8.33329C8.88087 8.33329 10.0002 7.214 10.0002 5.83329C10.0002 4.45258 8.88087 3.33329 7.50016 3.33329Z",
    fill: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8602 12.4C15.9752 11.9544 16.4297 11.6864 16.8754 11.8014C18.7139 12.2762 19.9989 13.9339 20.0004 15.8327L20.0004 17.5C20.0004 17.9602 19.6273 18.3333 19.167 18.3333C18.7068 18.3333 18.3337 17.9602 18.3337 17.5V15.8339C18.3337 15.8339 18.3337 15.834 18.3337 15.8339C18.3327 14.6947 17.5617 13.7 16.4587 13.4152C16.0131 13.3001 15.7451 12.8456 15.8602 12.4Z",
    fill: "gray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5262 2.40161C12.6404 1.95576 13.0944 1.68687 13.5402 1.80102C15.3839 2.27307 16.6734 3.93435 16.6734 5.83748C16.6734 7.74062 15.3839 9.40189 13.5402 9.87394C13.0944 9.9881 12.6404 9.7192 12.5262 9.27335C12.4121 8.82749 12.681 8.37351 13.1268 8.25936C14.233 7.97613 15.0067 6.97936 15.0067 5.83748C15.0067 4.6956 14.233 3.69884 13.1268 3.41561C12.681 3.30145 12.4121 2.84747 12.5262 2.40161Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGrey);
export default __webpack_public_path__ + "static/media/users-grey.2c6db6a8e47e0da1d8546b2d4055e265.svg";
export { ForwardRef as ReactComponent };